import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';

import Typography from '@ts-core/components/Typography';

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.secondary.contrastText,
    fontWeight: 500,
  },
}));

const StudentsInfo = (props) => {
  const classes = useStyles();
  const { course, loading } = props;

  return (
    <Link to={`/${course._id}/students`} className={classes.text}>
      <Typography
        variant="subtitle1"
        className={classes.text}
        loading={loading}
        skeletonWidth={60}
      >
        <FormattedMessage
          id="course.numberOfStudents"
          values={{ students: course.students || 0 }}
        />
      </Typography>
    </Link>
  );
};

StudentsInfo.propTypes = {
  course: PropTypes.object,
  loading: PropTypes.bool,
};

StudentsInfo.defaultProps = {
  course: {},
  loading: false,
};

export default StudentsInfo;
